// extracted by mini-css-extract-plugin
export default {"container":"Phl3P_ZRwxpftZvjvJ6w"};